import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";

import axios from "axios";

import { aoiActions, dataActions, dataExplorerActions } from "../../store";
import { entities } from "../../config/config.dataExplorer";
import { API_URL } from "../../config/config.data";

const DEFAULT_AOI_CATEGORY = "ngwos-basin";
const ALL_BASINS_LABEL = "All basins (including national projects)";

export default function BasinSelection() {
  const dispatch = useDispatch();

  const basins = useSelector((state) => state.data?.basins?.data);
  const sites = useSelector((state) => state.data?.sites?.data);

  const selectedEntity = useSelector(
    (state) => state.dataExplorer.selectedEntity
  );
  const filters = useSelector(
    (state) => state.dataExplorer.filters[selectedEntity]
  );
  const selectedBasins = filters["ngwos_basin"] || [];

  const getBasins = async () => {
    const basinsConfig = entities.basins;
    try {
      const response = await axios.get(`${API_URL}/basins`);
      const newOptions = response.data[basinsConfig.endpoint];

      const formattedOptions = newOptions.map((option) => {
        const label = option.name || "Unknown";
        return {
          label: label,
          id: option.id,
          abbreviation: label
            .split(/[\s-]+/)
            .map((word) => word[0].toUpperCase())
            .join(""),
        };
      });

      return formattedOptions;
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const allBasinsOption = {
    label: "All basins (including national projects)",
    id: 0,
    abbreviation: "All",
  };

  const [options, setOptions] = useState([allBasinsOption]);

  useEffect(() => {
    const fetchAndSetBasins = async () => {
      const fetchedBasins = await getBasins();
      setOptions([allBasinsOption, ...fetchedBasins]);
    };
    fetchAndSetBasins();
  }, []);

  const labels = options
    .map((option) => option.label)
    .filter((label) => label !== ALL_BASINS_LABEL);

  const handleCheckboxChange = (e) => {
    const value = e.target.value;

    if (value === ALL_BASINS_LABEL) {
      let selectedIds = [];
      let filterValue = [];

      if (
        !labels.every((val) => selectedBasins.includes(val)) ||
        selectedBasins.length === 0
      ) {
        selectedIds = options
          .filter((option) => option.id !== 0)
          .map((option) => option.id);
        filterValue = labels;
      }

      // dispatch(
      //   aoiActions.setSelection({
      //     catId: selectedIds.length ? DEFAULT_AOI_CATEGORY : null,
      //     selectedIds: selectedIds,
      //   })
      // );
      dispatch(
        dataExplorerActions.setFilter({
          id: "ngwos_basin",
          value: filterValue,
          selectedEntity,
        })
      );
    } else {
      // handle normal cases for single basin (de)selection
      const newSelectedBasins = selectedBasins.includes(value)
        ? selectedBasins.filter((val) => val !== value)
        : [...selectedBasins, value];
      
      const filteredBasins = basins.filter((basin) => newSelectedBasins.includes(basin.name));

      // set aoi selection  
      const newSelectedBasinIds = options
        .filter((option) => newSelectedBasins.includes(option.abbreviation))
        .map((option) => option.id);

      dispatch(
        aoiActions.setSelection({
          catId: DEFAULT_AOI_CATEGORY,
          selectedIds: newSelectedBasinIds,
        })
      );

      // set dataset filter
      dispatch(
        dataExplorerActions.setFilter({
          id: "ngwos_basin",
          value: newSelectedBasins,
          selectedEntity,
        })
      );

      const filteredSites = sites?.filter((site) => {
        for (const project of site["projects"]) {
          if (filteredBasins.map(basin => basin.id).includes(project.basin_id)) {
            return true
          }
        }
      });
      dispatch(dataActions.setFilteredSiteData(filteredSites));
    }
  };

  return (
    <FormControl>
      {options
        .sort((a, b) => a.label.localeCompare(b.label))
        .map((option) => {
          const isAllBasinsOption = option.abbreviation === "All";
          const isChecked = isAllBasinsOption
            ? labels.every((val) => selectedBasins.includes(val)) &&
            selectedBasins.length > 0
            : selectedBasins.includes(option.label);

          return (
            <FormControlLabel
              key={option.id}
              control={
                <Checkbox
                  color="secondary"
                  checked={isChecked}
                  onChange={handleCheckboxChange}
                  value={option.label}
                />
              }
              label={option.label}
            />
          );
        })}
    </FormControl>
  );
}
